import {
} from '../actions/property_visit_action';
import {CreateReducer} from '../utils/create_reducer';
import { PROPERTY_VISIT_API_URL } from '../constants/api_routes';
import { GET_CREATE_PV_REPORT_DETAILS,CLEAR_DATA } from '../actions/property_visit_action';

const initState = {
    isFetching:true,
    data: [],
}

const pvReducer = CreateReducer(initState, {
    [GET_CREATE_PV_REPORT_DETAILS](state, action) {
        return {...initState,data:action.payload.property_visit, isFetching:false};
        
    },
    [CLEAR_DATA](state, action) {
        return {...initState,change:!state.change};
    },
});

export default pvReducer;


// WEBPACK FOOTER //
// ./src/reducers/property_visit_reducer.js